import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './config/firebase'; // Initialize Firebase
import * as Sentry from "@sentry/react";

import { QueryClient, QueryClientProvider } from '@tanstack/react-query';

// Initialize Sentry
Sentry.init({
  dsn: "https://19ce7cc8bbc90219dc8cf2da979a2727@o4510618091454464.ingest.de.sentry.io/4510800734847056",
  integrations: [
    Sentry.browserTracingIntegration(),
    Sentry.replayIntegration({
      maskAllText: false,
      blockAllMedia: false,
    }),
  ],
  tracesSampleRate: 0.1, // Capture 10% of transactions
  replaysSessionSampleRate: 0.1, // Sample 10% of sessions
  replaysOnErrorSampleRate: 1.0, // Sample 100% of sessions with errors
  environment: import.meta.env.MODE,
  sendDefaultPii: true,
  enableLogs: true,
});

// Register service worker via vite-plugin-pwa helper (if plugin is installed)
try {
  // `virtual:pwa-register` is provided by `vite-plugin-pwa`
  // This will register the generated service worker and auto-update it
  // eslint-disable-next-line @typescript-eslint/no-var-requires
  const { registerSW } = require('virtual:pwa-register');
  const updateSW = registerSW({ immediate: true });
} catch (e) {
  // plugin not installed in dev environment or module not available
}

// Create a client
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 1000 * 60 * 5, // 5 minutes default
      retry: 1,
    },
  },
});

const rootElement = document.getElementById('root');
if (!rootElement) {
  throw new Error("Could not find root element to mount to");
}

const root = ReactDOM.createRoot(rootElement);
root.render(
  <React.StrictMode>
    <Sentry.ErrorBoundary fallback={<div>Ha ocurrido un error. Por favor, recarga la página.</div>}>
      <QueryClientProvider client={queryClient}>
        <App />
      </QueryClientProvider>
    </Sentry.ErrorBoundary>
  </React.StrictMode>
);